// extracted by mini-css-extract-plugin
export default {"item":"TeeTime_item__GmPQU","disabled":"TeeTime_disabled__J6CXE","highlighted":"TeeTime_highlighted__uSWTy","spin":"TeeTime_spin__f71+5","tooltip":"TeeTime_tooltip__ErWDq"};